import { render, staticRenderFns } from "./Dashboard6.vue?vue&type=template&id=8dc62fa2"
import script from "./Dashboard6.vue?vue&type=script&lang=js"
export * from "./Dashboard6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports